import React from "react";
import {ListItemButton} from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InstallMobileIcon from "@mui/icons-material/InstallMobile";
import {useMenuTranslation} from "../menu/menuTranslationContext";
import {useInstallApp} from "./useInstallApp";
import {IosInstallDialog} from "./IosInstallDialog";

/**
 * "Installer app" in the menu: the permanent way to install DAMS, also after "Ikke nå" (DE-1707).
 *
 * It leaves the menu open, so the iOS dialog can return focus to this item.
 */
export const InstallAppMenuItem = () => {
    const t = useMenuTranslation();
    const {showMenuItem, install, iosDialogOpen, closeIosDialog} = useInstallApp();

    return <>
        {showMenuItem && (
            <ListItemButton onClick={install}>
                <ListItemIcon>
                    <InstallMobileIcon/>
                </ListItemIcon>
                <ListItemText primary={t('installAppMenuItem', 'Installer app')}/>
            </ListItemButton>
        )}
        <IosInstallDialog open={iosDialogOpen} onClose={closeIosDialog}/>
    </>;
};
